<template>
  <a-card :bordered="false">
    <search-page-view
      ref="table"
      rowKey="dataOtherOrderNo"
      :col="3"
      :item-names="['s1', 's2', 's3', 's4']"
      :columns="columns"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
    >
      <a-form-item slot="s1" label="商品名称" v-bind="searchItemLayout">
        <a-input v-model="queryParams.dataItemName" placeholder="请输入"></a-input>
      </a-form-item>
      <a-form-item slot="s2" label="订单编号" v-bind="searchItemLayout">
        <a-input v-model="queryParams.dataOtherOrderNo" placeholder="请输入"></a-input>
      </a-form-item>
      <a-form-item slot="s3" label="订单类型" v-bind="searchItemLayout">
        <a-select v-model="queryParams.dataProCatalog" style="width: 100%;">
          <a-select-option :value="0">全部</a-select-option>
          <a-select-option :value="1">旅游门票</a-select-option>
          <a-select-option :value="2">酒店</a-select-option>
          <a-select-option :value="8">抢购</a-select-option>
          <a-select-option :value="83">预约</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item slot="s4" label="状态" v-bind="searchItemLayout">
        <a-select v-model="queryParams.dataStatus" style="width: 100%;">
          <a-select-option :value="0">全部</a-select-option>
          <a-select-option :value="1">订单导入成功</a-select-option>
          <a-select-option :value="2">订单导入失败</a-select-option>
          <a-select-option :value="3">订单创建中</a-select-option>
          <a-select-option :value="4">订单创建成功</a-select-option>
          <a-select-option :value="5">创建失败</a-select-option>
        </a-select>
      </a-form-item>
      <template slot="index" slot-scope="rowItem">{{ rowItem.index + 1 }}</template>
      <div slot="action" slot-scope="rowItem">
        <a
          v-if="rowItem.record.dataStatus == 2 || rowItem.record.dataStatus == 5"
          @click="createCodeEvent(rowItem.record.dataId)"
        >编辑</a
        >
        <a
          v-if="rowItem.record.dataStatus == 1 || rowItem.record.dataStatus == 4"
          @click="orderSee(rowItem.record.dataId)"
        >查看详情</a
        >
      </div>
      <div slot="remarks" slot-scope="rowItem" v-if="rowItem.record.dataStatus == 2 || rowItem.record.dataStatus == 5">
        <div class="item-proInfo">
          <a-tooltip placement="leftTop">
            <template slot="title">
              <div v-for="(i, idx) in rowItem.record.dataLog" :key="idx">
                {{ i }}
              </div>
            </template>
            <div v-for="(i, idx) in rowItem.record.dataLog" :key="idx">{{ i }}...</div>
          </a-tooltip>
        </div>
      </div>
    </search-page-view>
    <a-modal title="编辑" :visible="visible" @ok="handleOk" @cancel="visible = false" width="800px">
      <div class="editDetail">
        <a-card :bordered="false" title="订单信息">
          <table class="tab1">
            <tr>
              <td>订单号</td>
              <td>订单类型(必填)(酒店订单、门票订单、抢购订单、预约订单)</td>
              <td>项目名称(必填)</td>
              <td>酒店/商品ID(必填)</td>
              <td>房型ID/票型ID/套餐ID(必填)</td>
              <td>价格计划ID(无价格计划空白即可)</td>
              <td>数量/间夜(必填)</td>
              <td>入住日期/游玩日期(必填)</td>
              <td>离店日期(有则必填，没有空白)</td>
              <td>订单金额(必填)</td>
              <td>联系人(必填)</td>
              <td>联系电话(必填)</td>
              <td>收货地址(抢购)有则必填</td>
              <td>QQ号(选填)</td>
              <td>邮箱(选填)</td>
              <td>微信(选填)</td>
              <td>身份证(选填)</td>
              <td>备注(选填)</td>
            </tr>
            <tr>
              <td>{{ detailInfo.dataOtherOrderNo }}</td>
              <td>
                <a-input v-model="detailInfo.dataProCatalog"/>
              </td>
              <td>
                <a-input v-model="detailInfo.dataItemName"/>
              </td>
              <td>
                <a-input v-model="detailInfo.dataProId"/>
              </td>
              <td>
                <a-input v-model="detailInfo.dataOptionId"/>
              </td>
              <td>
                <a-input v-model="detailInfo.dataRatePlanId"/>
              </td>
              <td>
                <a-input v-model="detailInfo.dataPurchaseQuantity"/>
              </td>
              <td>
                <a-input v-model="detailInfo.dataCheckinDate"/>
              </td>
              <td>
                <a-input v-model="detailInfo.dataDepartureDate"/>
              </td>
              <td>
                <a-input v-model="detailInfo.dataAmount"/>
              </td>
              <td>
                <a-input v-model="detailInfo.dataContactName"/>
              </td>
              <td>
                <a-input v-model="detailInfo.orderContactPhone"/>
              </td>
              <td>
                <a-input v-model="detailInfo.dataContactReceiptAddress"/>
              </td>
              <td>
                <a-input v-model="detailInfo.dataContactQq"/>
              </td>
              <td>
                <a-input v-model="detailInfo.dataContactEmail"/>
              </td>
              <td>
                <a-input v-model="detailInfo.dataContactWeixin"/>
              </td>
              <td>
                <a-input v-model="detailInfo.dataContactCardId"/>
              </td>
              <td>
                <a-input v-model="detailInfo.dataOrderRemark"/>
              </td>
            </tr>
          </table>
        </a-card>
        <a-card
          :bordered="false"
          title="游客信息"
          v-if="detailInfo.travellerDateList && detailInfo.travellerDateList.length"
        >
          <table class="tab2">
            <tr>
              <td>序号</td>
              <td>游客姓名</td>
              <td>游客联系方式</td>
              <td>证件类型</td>
              <td>游客证件号码</td>
            </tr>
            <tr v-for="(v, k) in detailInfo.travellerDateList" :key="k">
              <td>{{ k + 1 }}</td>
              <td>
                <a-input v-model="v.dataTravellersName"/>
              </td>
              <td>
                <a-input v-model="v.dataTravellersPhone"/>
              </td>
              <td>
                <a-input v-model="v.dataTravellersCardType"/>
              </td>
              <td>
                <a-input v-model="v.dataTravellersCardNo"/>
              </td>
            </tr>
          </table>
        </a-card>
      </div>
    </a-modal>

    <a-modal title="商品详情" :visible="detailVisible" @cancel="detailVisible = false" :footer="null" width="800px">
      <div class="detalMain">
        <a-form-item label="类型" v-bind="customFormItemLayout">
          {{ detailInfo.dataProCatalog }}
        </a-form-item>
        <a-form-item label="订单号" v-bind="customFormItemLayout">
          {{ detailInfo.dataOtherOrderNo }}
        </a-form-item>
        <a-card :bordered="false" title="商品信息">
          <a-form-item label="商品名称" v-bind="customFormItemLayout">
            {{ detailInfo.dataItemName }}
          </a-form-item>
          <a-form-item label="票型" v-bind="customFormItemLayout">
            {{ detailInfo.dataOptionId }}
          </a-form-item>
          <a-form-item label="数量" v-bind="customFormItemLayout">
            {{ detailInfo.dataPurchaseQuantity }}
          </a-form-item>
          <a-form-item label="出游日期" v-bind="customFormItemLayout">
            {{ detailInfo.dataCheckinDate }}
          </a-form-item>
          <a-form-item label="结算金额" v-bind="customFormItemLayout">
            {{ detailInfo.dataAmount }}
          </a-form-item>
        </a-card>
        <a-card :bordered="false" title="联系人">
          <a-form-item label="姓名" v-bind="customFormItemLayout">
            {{ detailInfo.dataContactName }}
          </a-form-item>
          <a-form-item label="联系电话" v-bind="customFormItemLayout">
            {{ detailInfo.orderContactPhone }}
          </a-form-item>
        </a-card>
        <a-card :bordered="false" title="出游人">
          <div v-for="(v, k) in detailInfo.travellerDateList" :key="k">
            <a-form-item :label="'出游人' + (k + 1)" v-bind="customFormItemLayout">
              <span style="display: inline-block; width: 120px;">{{ v.dataTravellersName }}</span> 身份证：
              {{ v.dataTravellersCardNo }}
            </a-form-item>
          </div>
        </a-card>
      </div>
    </a-modal>
  </a-card>
</template>

<script>
import searchForm from '../../../../utils/mixins/searchFormMixins'

export default {
  name: 'BatchOrder',
  mixins: [searchForm],
  data() {
    return {
      type: 1,
      queryParams: {
        dataProCatalog: 0,
        dataStatus: 0
      },
      loadPromise: params => this.getListPromise(params),
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          scopedSlots: { customRender: 'index' }
        },
        {
          title: '导单时间',
          dataIndex: 'dataUpdateTime'
        },
        {
          title: '订单号',
          dataIndex: 'dataOtherOrderNo'
        },
        {
          title: '项目名称',
          dataIndex: 'dataItemName'
        },
        {
          title: '商品名称',
          dataIndex: 'dataProName'
        },
        {
          title: '订单类型',
          dataIndex: 'dataProCatalog'
        },
        {
          title: '订单导入状态',
          dataIndex: 'dataStatusStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        },
        {
          title: '备注',
          dataIndex: 'remarks',
          width: '180px',
          scopedSlots: { customRender: 'remarks' }
        }
      ],
      visible: false,
      detailVisible: false,
      customFormItemLayout: {
        labelCol: {
          span: 3
        },
        wrapperCol: {
          span: 15
        }
      },
      detailInfo: ''
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    refresh() {
      this.$refs.table.refresh(true)
    },
    // 获取列表数据接口
    getListPromise(params) {
      this.queryParams = {
        ...params
      }
      return this.getHttpServices().getOrderService().post('resources/order/get/handworkOrder/record', this.queryParams)
    },
    createCodeEvent(dataId) {
      this.visible = true
      this.getDtailInfo(dataId)
    },
    handleOk() {
      if (!this.detailInfo.dataProCatalog) {
        this.$message.error('请输入订单类型')
        return
      }
      if (!this.detailInfo.dataOptionId) {
        this.$message.error('请输入酒店/商品ID')
        return
      }
      if (!this.detailInfo.dataItemName) {
        this.$message.error('请输入项目名称')
        return
      }
      if (!this.detailInfo.dataRatePlanId) {
        this.$message.error('请输入票型ID')
        return
      }
      if (!this.detailInfo.dataPurchaseQuantity) {
        this.$message.error('请输入数量')
        return
      }
      if (!this.detailInfo.dataCheckinDate) {
        this.$message.error('请输入入住日期/出游日期')
        return
      }
      if (!this.detailInfo.dataAmount) {
        this.$message.error('请输入订单金额')
        return
      }
      if (!this.detailInfo.dataContactName) {
        this.$message.error('请输入联系人名称')
        return
      }
      if (!this.detailInfo.orderContactPhone) {
        this.$message.error('请输入联系人电话')
        return
      }
      this.getHttpServices().getOrderService().post('resources/order/update/handworkOrderDetail', this.detailInfo)
        .then(res => {
          this.$message.success('修改成功')
          this.$refs.table.refresh()
          this.visible = false
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    orderSee(dataId) {
      this.detailVisible = true
      this.getDtailInfo(dataId)
    },
    getDtailInfo(dataId) {
      let parm = {
        dataId
      }
      this.getHttpServices().getOrderService().post('resources/order/get/handworkOrderDetail', parm)
        .then(res => {
          this.detailInfo = res
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }

}
</script>
<style lang="less" scoped>
.detalMain .ant-form-item {
  margin-bottom: 0;
}

.editDetail {
  width: 750px;
  overflow: scroll;

  table.tab1 {
    border: 1px #f1f1f1 solid;
    width: 1800px;

    tr {
      td {
        border: 1px #f1f1f1 solid;
        text-align: center;
      }
    }
  }

  table.tab2 {
    border: 1px #f1f1f1 solid;

    tr {
      td {
        border: 1px #f1f1f1 solid;
        text-align: center;
      }
    }
  }
}

.item-proInfo {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
}
</style>
